import { render, staticRenderFns } from "./OutstandingTab.vue?vue&type=template&id=270b144a&scoped=true"
import script from "./OutstandingTab.vue?vue&type=script&lang=js"
export * from "./OutstandingTab.vue?vue&type=script&lang=js"
import style0 from "./OutstandingTab.vue?vue&type=style&index=0&id=270b144a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b144a",
  null
  
)

export default component.exports